import { typesenseEnabled } from '../../libs/search/searchClient'

// Engine-native filter primitives for the clauses WE build in JS, where the
// field and its type are known at the call site. NOT a port of
// Search::FilterBy and must not become one — arbitrary Algolia strings are
// parsed server-side (SearchHelper#engine_filter_string).

// Backtick-quoted unless a bare number or boolean. Mirrors
// Search::FilterBy#escape; keep the two in step.
export function escapeValue (value) {
  const string = String(value)
  if (/^-?\d+(\.\d+)?$/.test(string) || ['true', 'false'].includes(string.toLowerCase())) {
    return string
  }

  return '`' + string.replace(/`/g, '') + '`'
}

// Exact match on a string field; a plain `:` is a token match on Typesense.
export function exactMatch (field, value) {
  return typesenseEnabled()
    ? `${field}:=${escapeValue(value)}`
    : `${field}:"${value}"`
}

// Numeric comparison: Algolia spaces the operator, Typesense folds it in
// after the colon.
export function compare (field, operator, value) {
  return typesenseEnabled()
    ? `${field}:${operator}${value}`
    : `${field} ${operator} ${value}`
}

// Bool/numeric equality reads the same on both engines.
export function equals (field, value) {
  return `${field}:${value}`
}

export function all (clauses) {
  return clauses.filter(Boolean).join(typesenseEnabled() ? ' && ' : ' AND ')
}

// Parenthesised: almost always AND-ed into a larger string.
export function any (clauses) {
  const parts = clauses.filter(Boolean)
  if (parts.length === 0) return ''
  if (parts.length === 1) return parts[0]

  return `(${parts.join(typesenseEnabled() ? ' || ' : ' OR ')})`
}
